"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var Warn_1 = require("../../../img/Warn");
var styles = require("../../../styles/NavigationPanel");
var MapperUtils_1 = require("../../../util/MapperUtils");
var Utils_1 = require("../../../util/Utils");
var NavigationContext_1 = require("../../base/NavigationContext");
var VerticalLine_1 = require("../../base/VerticalLine");
var ModelResultNavSubmenu = function () {
    var refs = React.useContext(NavigationContext_1.NavigationContext);
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), alerts = _a.alerts, status = _a.status;
    var unresolvedAlerts = (0, MapperUtils_1.getRecommendedAlerts)(alerts);
    var _b = React.useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var hasAlerts = unresolvedAlerts.length > 0;
    var improvePerfLabel = (React.createElement("div", null,
        Localize_1.Messages.modelResultImprovePerformanceTitle(),
        hasAlerts && (React.createElement("div", { className: styles.navWarningPill },
            React.createElement(Warn_1.Warn, null),
            " ",
            unresolvedAlerts.length))));
    var reviewModelSubmenu = [
        { header: Localize_1.Messages.modelReviewOverview(), navigationKey: 'MODEL_RESULT_OVERVIEW' },
        {
            header: improvePerfLabel,
            navigationKey: 'MODEL_RESULT_IMPROVE_PERFORMANCE',
            color: hasAlerts ? styles.SUBMENU_WARNING_COLOR : undefined,
        },
        { header: Localize_1.Messages.modelResultReviewPerformanceTitle(), navigationKey: 'MODEL_RESULT_REVIEW_PERFORMANCE' },
        { header: Localize_1.Messages.ModelResultAdditionalMetricsNavTitle(), navigationKey: 'MODEL_RESULT_ADDITIONAL_PERFORMANCE_METRICS' },
        { header: Localize_1.Messages.ModelResultExamineModelTitle(), navigationKey: 'MODEL_RESULT_EXAMINE_MODEL' },
    ];
    var onSubMenuClick = function (submenu) {
        setActiveIndex(reviewModelSubmenu.findIndex(function (n) { return n.navigationKey === submenu.navigationKey; }));
    };
    /** Handles on click synchronously */
    React.useEffect(function () {
        var navigationKey = reviewModelSubmenu[activeIndex].navigationKey;
        var sectionRef = refs[navigationKey];
        sectionRef === null || sectionRef === void 0 ? void 0 : sectionRef.scrollIntoView();
    }, [activeIndex]);
    return (React.createElement(React.Fragment, null, status === Utils_1.REDUX_STATUS.succeeded &&
        reviewModelSubmenu.map(function (submenu, submenu_index) {
            var _a;
            var submenuCircleBgColor = (_a = submenu.color) !== null && _a !== void 0 ? _a : styles.SUBMENU_DEFAULT_COLOR;
            return (React.createElement("div", { className: styles.navSubMenuContainer, key: "modelresults_submenu_".concat(submenu_index) },
                submenu_index === 0 && React.createElement(VerticalLine_1.default, null),
                React.createElement("div", { className: styles.navRow },
                    React.createElement("div", { className: styles.navSubMenuCircle, style: { backgroundColor: submenuCircleBgColor } }),
                    React.createElement("div", { className: "".concat(styles.navSubMenuText, " ").concat(styles.navTextClickable), onClick: function () { return onSubMenuClick(submenu); }, onKeyPress: function (event) { return event.key === 'Enter' && onSubMenuClick(submenu); }, role: "button", tabIndex: 0 }, submenu.header)),
                submenu_index !== reviewModelSubmenu.length - 1 && React.createElement(VerticalLine_1.default, null)));
        })));
};
exports.default = ModelResultNavSubmenu;
//# sourceMappingURL=ModelResultNavSubmenu.js.map